import { render, staticRenderFns } from "./DashboardWidgetGrid.vue?vue&type=template&id=60aa47d6&scoped=true"
import script from "./DashboardWidgetGrid.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetGrid.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetGrid.vue?vue&type=style&index=0&id=60aa47d6&prod&lang=css"
import style1 from "./DashboardWidgetGrid.vue?vue&type=style&index=1&id=60aa47d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa47d6",
  null
  
)

export default component.exports